import { forAllCallback } from "../../../scripts/utils/helpers"; //"../../../scripts/utils/helpers";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default (function () {
    var init = function () {
        forAllCallback(".fade-in", function (el) {
            var tween = gsap.from(el, {
                opacity: 0,
                duration: 0.5,
                delay: 0.3,
            });
            ScrollTrigger.create({
                trigger: el,
                start: "top bottom",
                end: "bottom top",
                animation: tween,
                once: false,
                toggleActions: "restart none restart none",
            });
        });
    };
    init();
});
